'use client';

import { c as _c } from "react/compiler-runtime";
import { Button } from '@common/components';
import { SvgChevronright } from '@common/icon';
import { cn } from '@core/utils';
import { DONATION_ROUTES } from '@/constants';
import { useCustomRouter } from '@/hooks/useCustomRouter';
export interface CartEmptyStateProps {
  className?: string;
}
export const CartEmptyState = t0 => {
  const $ = _c(11);
  const {
    className
  } = t0;
  const {
    push
  } = useCustomRouter();
  let t1;
  if ($[0] !== className) {
    t1 = cn("flex min-h-[calc(100dvh-98px)] flex-col items-center justify-center gap-24 px-20", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <p className="text-center font-400 text-Gray-550 typo-body3">아직 담긴 답례품이 없어요.<br />마음에 드는 답례품을 골라보세요.</p>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== push) {
    t3 = () => push(DONATION_ROUTES.GIFTS.pathname);
    $[3] = push;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <SvgChevronright className="size-10 text-Gray-600" />;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t3) {
    t5 = <Button dimensions="H48" theme="sub-line" onClick={t3} className="gap-6">답례품 보러가기{t4}</Button>;
    $[6] = t3;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t1 || $[9] !== t5) {
    t6 = <div className={t1}>{t2}{t5}</div>;
    $[8] = t1;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  return t6;
};